import { Dimensions, Metrics } from 'components/insights/constants';
import { formatPercentage } from 'components/insights/formatting';
import AnalyticsResponseRollupCollection from 'components/insights/query/AnalyticsResponseRollupCollection';
import { useReferralsInsightsStore } from 'stores/referralsInsightsStore';

import { formatResponseTime } from '../constants';

import { readGrandTotal, readGrandTotalOrZero, readReferralRate } from './rollupHelpers';
import { StatTile, TilesGrid } from './statTiles';

type Props = {
  loading: boolean;
  rollups: AnalyticsResponseRollupCollection;
};

export default function SummaryDetailHeader({ loading, rollups }: Props) {
  const slideoutContext = useReferralsInsightsStore((state) => state.slideoutContext);
  const totalReferrals = readGrandTotalOrZero(rollups, Metrics.REVIEW_ID_COUNT);
  const acceptance = readReferralRate(rollups, Metrics.ACCEPTANCE_RATE);
  const denial = readReferralRate(rollups, Metrics.DENIAL_RATE);
  const avgResponseTime = readGrandTotal(rollups, Metrics.RESPONSE_TIME_SECONDS_AVERAGE);

  const countLabel =
    slideoutContext?.kind === 'entity' && slideoutContext.dimension === Dimensions.SENDING_GROUP
      ? 'Referrals Sent'
      : 'Referrals Received';

  return (
    <TilesGrid $columns={4}>
      <StatTile label={countLabel} loading={loading} primary={totalReferrals.toLocaleString()} />
      <StatTile
        label='Acceptance Rate'
        tone='green'
        loading={loading}
        primary={formatPercentage(acceptance.rate)}
        addendum={acceptance.rate != null ? `${acceptance.count} of ${acceptance.total} referrals` : undefined}
      />
      <StatTile
        label='Denial Rate'
        tone='red'
        loading={loading}
        primary={formatPercentage(denial.rate)}
        addendum={denial.rate != null ? `${denial.count} of ${denial.total} referrals` : undefined}
      />
      <StatTile label='Avg. Response Time' loading={loading} primary={formatResponseTime(avgResponseTime)} />
    </TilesGrid>
  );
}
